import { Component, OnInit, Input } from '@angular/core';
import { dialogConfig } from '@modals/dialog.configure';
import { MbDialog } from '@am/moebius';
import { ModalChargesComponent } from '@modals/charges/charges.component';
import { CheckRoomService } from '@core/services';
import { IExcluded } from '@core/models/modals';

@Component({
    selector: 'charges',
    templateUrl: './charges.component.html',
    styleUrls: ['./charges.component.scss'],
    standalone: true,
})
export class ChargesComponent implements OnInit {
  @Input()
  rate: any;

  public excluded: any;
  public extraCharge: any;
  public currencyCode: any;

  public specialCharges = ['JUNIPER_EXTRA_CHARGE', 'TEXT_EXTRA_CHARGE'];
  public addRemark = true;

  constructor(
    private dialog: MbDialog,
    private checkRoomRateService: CheckRoomService,
  ) {}

  ngOnInit() {
    this.currencyCode = this.rate.price.currency.code;
  }

  public openDialog() {
    if (!this.dialog.isAnyDialogOpen) {
      this.checkRoomRateService.getRoomRate(this.rate, false).subscribe((res) => {
        this.excluded = this.getExcluded(res);
        this.extraCharge = this.getExtraChargeAndRemarks(res);

        const dialogData = {
          excluded: this.excluded,
          currencyCode: this.currencyCode,
          extraCharge: this.extraCharge,
        };
        this.dialog.open(ModalChargesComponent, {
          ...dialogConfig,
          closeBtn: true,
          dialogData: dialogData,
        });
      });
    }
  }

  private getExcluded(rate: any) {
    return rate.price.charges.reduce((acc, charge) => {
      if (!charge.included && !this.specialCharges.includes(charge.type)) {
        const excluded: IExcluded = {
          description: charge.description,
          amount: charge.amount,
        };
        acc.push(excluded);
      }
      return acc;
    }, []);
  }

  private getExtraChargeAndRemarks(rate: any) {
    const extraCharges = this.getExtraCharge(rate);
    return this.addRemarks(extraCharges, rate);
  }

  private getExtraCharge(rate: any) {
    return rate.price.charges.reduce((acc, charge) => {
      if (!charge.included && this.specialCharges.includes(charge.type)) {
        const extraCharge: IExcluded = {
          description: charge.description,
          amount: charge.amount,
        };
        acc.push(extraCharge);
        this.addRemark = false;
      }
      return acc;
    }, []);
  }

  private addRemarks(extraCharges: IExcluded[], rate: any) {
    if (this.addRemark && !!rate.remarks) {
      extraCharges.push({ description: rate.remarks });
    }
    return extraCharges;
  }
}
